
import React, { useEffect, useState, useMemo } from 'react'
import { ObjectType } from './ObjectType';
import { ObjectInstance } from './ObjectInstance';
import { Category } from './Category';
import { Price } from './Price';
import { Period } from './Period';
import { 
  Col, Layout, Menu, Row, 
  Card, Space, Button, Switch, Typography,
  Avatar,  Tooltip, Divider, 
  Drawer, Input,  List,   
  FloatButton, Segmented, theme
} from 'antd';
import { Header } from 'antd/es/layout/layout';
import Sider from 'antd/es/layout/Sider';
import {
    BookOutlined,
    CalculatorOutlined,
    CoffeeOutlined,
    CopyOutlined,
    DollarOutlined,
    FieldTimeOutlined,
    GroupOutlined,
    HistoryOutlined,
    PlusOutlined,
    SearchOutlined,
    SettingOutlined,
    TeamOutlined,
    UnorderedListOutlined,
    UserOutlined,
    AppstoreOutlined,
    MenuOutlined,
    CloseOutlined,
    BulbOutlined,
    BulbFilled,
    HomeOutlined,
    CarOutlined,
    FileTextOutlined,
    DashboardOutlined,
    RocketOutlined,
    FontSizeOutlined,
    DatabaseOutlined,
    CalendarOutlined,
    QuestionCircleOutlined,
    InfoCircleOutlined,
    PhoneOutlined,
    GlobalOutlined,
    MailOutlined,
    GithubOutlined,
    LinkedinOutlined,
} from '@ant-design/icons';
import { NewReserve } from './NewReserve';
import { Setting } from './Setting';
import { UserAvatarComponent } from '../Components/Profile/UserAvatarComponent';
import { UserProfileComponent } from '../Components/Profile/UserProfileComponent';
import { CustomType } from './CustomType';
import { User } from './User';
import { CurrentUserReserves } from './CurrentUserReserves';
import { AdvanceSearch } from './AdvanceSearch';
import { Food } from './Food';
import { FoodPricePeriod } from './FoodPricePeriod';
import { FoodListPeriod } from './FoodListPeriod';
import { FoodReserve } from './FoodReserve';
import { ParkingPricePeriod } from './ParkingPricePeriod';
import { Kitchen } from './Kitchen';
import { Parking } from './Parking';
import { ObjectInstanceCalendar } from './ObjectInstanceCalendar';
import { DashboardComponent } from './DashboardComponent';
// در بخش import فایل Admin.jsx، کامپوننت‌های جدید را اضافه کنید:
import { SupportContact } from './Support/SupportContact';
import { FAQ } from './Support/FAQ';
import { AboutApp } from './Support/AboutApp';
import { Features } from './Support/Features';
import { DeveloperInfo } from './Support/DeveloperInfo';
import { WebsiteRedirect } from './Support/WebsiteRedirect';
import { Tutorials } from './Support/Tutorials';

const { Title, Text, Paragraph } = Typography;
const { useToken } = theme;
const { Search } = Input;

// ======================================================================
// استایل‌های پایه
const siderStyle = {
    textAlign: 'right',
    lineHeight: '30px',
    color: '#fff',
    backgroundColor: '#001529',
};

const layoutStyle = {
    overflow: 'hidden',
    width: '100%',
    height: '100vh'
};

const headerStyle = {
    color: 'rgba(255, 255, 255, 0.65)',
    height: 64,
    paddingInline: 20,
    lineHeight: '64px',
    backgroundColor: '#001529',
};

const menuStyle = {
    height: '100vh'
};

// ======================================================================


// ======================================================================
export const Admin = ({ setLoading, showMessage }) => {
    const { token } = useToken();
    const [view, setView] = useState('dashboard');
    const [collapsed, setCollapsed] = useState(false);
    const [profileVersion, setProfileVersion] = useState(1);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [activeGroup, setActiveGroup] = useState(null);
    const [menuSearch, setMenuSearch] = useState('');
    const [darkMode, setDarkMode] = useState(() => {
        const saved = localStorage.getItem('darkMode');
        return saved ? JSON.parse(saved) : false;
    });
    const [fontSize, setFontSize] = useState(14);
    const [colorTheme, setColorTheme] = useState('#1890ff');
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
const [supportLinks, setSupportLinks] = useState({
    website: 'https://hosseinienajafabadiha.com',
    email: 'info@hosseinienajafabadiha.com',
    phone: '031-42748879,80',
    // github: 'https://github.com/your-company',
    // linkedin: 'https://linkedin.com/company/your-company'
});
const [developerLinks, setdeveloperLinks] = useState({
    website: 'https://almasgrp.com/',
    email: 'ali.abedini@gmail.com',
    phone: '031-91090096 ',
    mobile: '09120690976',
     github: 'https://github.com/almasgrp',
     linkedin: 'https://linkedin.com/company/almasgrp'
});
// لینک‌های پشتیبانی
//   const supportLinks = {
//     website: 'https://hosseinienajafabadiha.com',
//     email: 'ali.abedini@gmail.com',
//     phone: '031-42748879,80',
//     whatsapp: 'https://@hoseinienajafabadiha'
// //    whatsapp: 'https://wa.me/989123456789'
//   };
    // =================================================================
    // تشخیص اندازه صفحه
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // ذخیره تم تاریک
    useEffect(() => {
        localStorage.setItem('darkMode', JSON.stringify(darkMode));
    }, [darkMode]);

    // =================================================================
    // گروه‌بندی منوها
    const menuGroups = useMemo(() => {
        const userRole = localStorage.getItem('role');
        const isSuperAdmin = userRole === 'SuperAdmin';
        const isAdmin = userRole === 'Admin';
        const isReception = userRole === 'Reception';

        const groups = [
            {
                key: 'dashboard',
                label: 'داشبورد',
                icon: <DashboardOutlined />,
                color: '#1890ff',
                items: [
                    { key: 'dashboard', label: 'داشبورد اصلی', icon: <HomeOutlined /> }
                ]
            }
        ];

        // اطلاعات پایه
        if (isSuperAdmin || isAdmin) {
            groups.push({
                key: 'base-info',
                label: 'اطلاعات پایه',
                icon: <DatabaseOutlined />,
                color: '#52c41a',
                items: [
                    ...(isSuperAdmin ? [{ key: '1', label: 'نوع موجودیت‌ها', icon: <BookOutlined /> },
                    { key: '2', label: 'مدیریت موجودیت‌ها', icon: <CopyOutlined /> },
                    { key: '3', label: 'دسته‌بندی‌ها', icon: <GroupOutlined /> }] : []),
                    { key: '10', label: 'مدیریت لیست‌ها', icon: <UnorderedListOutlined /> },
                    { key: '4', label: 'قیمت‌گذاری', icon: <CalculatorOutlined /> },
                    { key: '5', label: 'دوره‌های رزرو', icon: <FieldTimeOutlined /> },
                        { key: '13', label: 'مدیریت غذاها', icon: <CoffeeOutlined /> },
                        { key: '14', label: 'قیمت‌گذاری غذا', icon: <DollarOutlined /> },
                        { key: '15', label: 'برنامه غذایی', icon: <CoffeeOutlined /> },
                        { key: '17', label: 'قیمت‌گذاری پارکینگ', icon: <DollarOutlined /> }
                ]
            });
        }

        // رزرو اتاق
        groups.push({
            key: 'room-reservation',
            label: 'رزرو اتاق/غذا/پارکینگ',
            icon: <CalendarOutlined />,
            color: '#fa8c16',
            items: [
                { key: '6', label: 'رزرو جدید', icon: <PlusOutlined /> },
                { key: '7', label: 'رزروهای شما', icon: <HistoryOutlined /> },
                { key: '16', label: 'رزرو غذا و پارکینگ', icon: <PlusOutlined /> },
            ]
        });

        // گزارشات
        if (isSuperAdmin || isAdmin || isReception) {
            groups.push({
                key: 'search',
                label: 'گزارشات',
                icon: <SearchOutlined />,
                color: '#f5222d',
                items: [
                    { key: '12', label: 'جستجوی پیشرفته', icon: <SearchOutlined /> },
                ...((isSuperAdmin || isAdmin) ? [
                    { key: '20', label: 'گزارشات اتاق‌ها', icon: <FileTextOutlined /> }
                ] : []),
                        { key: '18', label: 'گزارشات آشپزخانه', icon: <SearchOutlined /> },
                        { key: '19', label: 'گزارشات پارکینگ', icon: <SearchOutlined /> }
                ]
            });
        }

        // کاربران
        groups.push({
            key: 'users',
            label: 'کاربران',
            icon: <TeamOutlined />,
            color: '#eb2f96',
            items: [
                ...((isSuperAdmin || isAdmin) ? [
                    { key: '11', label: 'مدیریت کاربران', icon: <TeamOutlined /> }
                ] : []),
                { key: '9', label: 'پروفایل', icon: <UserOutlined /> }
            ]
        });

        // تنظیمات
        if (isSuperAdmin || isAdmin) {
            groups.push({
                key: 'settings',
                label: 'تنظیمات',
                icon: <SettingOutlined />,
                color: '#faad14',
                items: [
                    { key: '8', label: 'تنظیمات سیستم', icon: <SettingOutlined /> }
                ]
            });
        }

        groups.push({
        key: 'support',
        label: 'پشتیبانی',
        icon: <QuestionCircleOutlined />,
        color: '#722ed1',
        items: [
            { key: 'support-contact', label: 'ارتباط با پشتیبانی', icon: <PhoneOutlined /> },
            { key: 'faq', label: 'سوالات متداول', icon: <QuestionCircleOutlined /> },
            { key: 'tutorials', label: 'آموزش‌ها', icon: <BookOutlined /> }
        ]
    });

    // درباره ما
    groups.push({
        key: 'about',
        label: 'درباره ما',
        icon: <InfoCircleOutlined />,
        color: '#13c2c2',
        items: [
            { key: 'about-app', label: 'معرفی برنامه', icon: <RocketOutlined /> },
            { key: 'features', label: 'امکانات و قابلیت‌ها', icon: <AppstoreOutlined /> },
            { key: 'developer', label: 'تهیه‌کننده برنامه', icon: <UserOutlined /> },
            { key: 'website', label: 'وب‌سایت اطلاع‌رسانی', icon: <GlobalOutlined /> }
        ]
    });


        return groups;
    }, []);

    // =================================================================
    // مدیریت تغییر view
    const handleViewChange = (viewKey) => {
        setView(viewKey);
        if (isMobile) {
            setMobileMenuOpen(false);
        }
        
        // پیدا کردن گروه مربوطه
        const group = menuGroups.find(g => g.items.some(i => i.key === viewKey));
        if (group) {
            setActiveGroup(group.key);
        }
    };

    // =================================================================
    // منوی اصلی
    const mainMenuItems = useMemo(() => {
        const userRole = localStorage.getItem('role');
        const isSuperAdmin = userRole === 'SuperAdmin';
        const isAdmin = userRole === 'Admin';
        const isReception = userRole === 'Reception';

        return [
            (isSuperAdmin ) ? {
                key: '1',
                icon: <BookOutlined />,
                label: 'مدیریت نوع موجودیت ها',
            } : null,
            (isSuperAdmin ) ? {
                key: '2',
                icon: <CopyOutlined />,
                label: 'مدیریت موجودیت ها',
            } : null,
            (isSuperAdmin ) ? {
                key: '3',
                icon: <GroupOutlined />,
                label: 'مدیریت دسته بندی ها',
            } : null,
            (isSuperAdmin || isAdmin) ? {
                key: '10',
                icon: <UnorderedListOutlined />,
                label: 'مدیریت لیست ها',
            } : null,
            (isSuperAdmin || isAdmin) ? {
                key: '4',
                icon: <CalculatorOutlined />,
                label: 'مدیریت قیمت گذاری',
            } : null,
            (isSuperAdmin || isAdmin) ? {
                key: '5',
                icon: <FieldTimeOutlined />,
                label: 'مدیریت دوره های رزرو',
            } : null,
            (isSuperAdmin || isAdmin) ? {
                key: '13',
                icon: <CoffeeOutlined />,
                label: 'مدیریت غذاها',
            } : null,
            (isSuperAdmin || isAdmin) ? {
                key: '14',
                icon: <DollarOutlined />,
                label: 'مدیریت قیمت گذاری غذا',
            } : null,
            (isSuperAdmin || isAdmin) ? {
                key: '17',
                icon: <DollarOutlined />,
                label: 'مدیریت قیمت گذاری پارکینگ',
            } : null,
            (isSuperAdmin || isAdmin) ? {
                key: '15',
                icon: <CoffeeOutlined />,
                label: 'مدیریت برنامه غذایی',
            } : null,
            (isSuperAdmin || isAdmin) ? {
                key: '11',
                icon: <TeamOutlined />,
                label: 'مدیریت کاربران',
            } : null,
            (isSuperAdmin || isAdmin || isReception) ? {
                key: '12',
                icon: <SearchOutlined />,
                label: 'جستجوی پیشرفته',
            } : null,
            (isSuperAdmin || isAdmin || isReception) ? {
                key: '18',
                icon: <CoffeeOutlined />,
                label: 'گزارشات آشپزخانه',
            } : null,
            (isSuperAdmin || isAdmin || isReception) ? {
                key: '19',
                icon: <CarOutlined />,
                label: 'گزارشات پارکینگ',
            } : null,
            (isSuperAdmin || isAdmin) ? {
                key: '20',
                icon: <SearchOutlined />,
                label: 'گزارشات اتاق ها',
            } : null,
            {
                key: '7',
                icon: <HistoryOutlined />,
                label: 'رزروهای شما',
            },
            {
                key: '16',
                icon: <CoffeeOutlined />,
                label: 'رزرو غذا و پارکنیگ',
            },
            {
                key: '6',
                icon: <PlusOutlined />,
                label: 'رزرو جدید',
            },
            (isSuperAdmin || isAdmin) ? {
                key: '8',
                icon: <SettingOutlined />,
                label: 'تنظیمات',
            } : null,
            {
                key: '9',
                icon: <UserOutlined />,
                label: 'پروفایل',
            },
// پشتیبانی
        {
            key: 'support-contact',
            icon: <PhoneOutlined />,
            label: 'ارتباط با پشتیبانی',
        },
        {
            key: 'faq',
            icon: <QuestionCircleOutlined />,
            label: 'سوالات متداول',
        },
        // درباره ما
        {
            key: 'about-app',
            icon: <RocketOutlined />,
            label: 'معرفی برنامه',
        },
        {
            key: 'features',
            icon: <AppstoreOutlined />,
            label: 'امکانات برنامه',
        },
        {
            key: 'developer',
            icon: <UserOutlined />,
            label: 'تهیه‌کننده برنامه',
        },
        {
            key: 'website',
            icon: <GlobalOutlined />,
            label: 'وب‌سایت اطلاع‌رسانی',
        },
        ].filter(item => item !== null);
    }, []);

    // =================================================================
    // رندر محتوا بر اساس view
    const renderContent = () => {
        if (view === 'dashboard') {
            return <DashboardComponent 
                setLoading={setLoading} 
                showMessage={showMessage}
                handleViewChange={handleViewChange}
            />;
        }

        switch(view) {
            case '1':
                return <ObjectType setLoading={setLoading} showMessage={showMessage} />;
            case '2':
                return <ObjectInstance setLoading={setLoading} showMessage={showMessage} />;
            case '3':
                return <Category setLoading={setLoading} showMessage={showMessage} />;
            case '4':
                return <Price setLoading={setLoading} showMessage={showMessage} />;
            case '5':
                return <Period setLoading={setLoading} showMessage={showMessage} />;
            case '6':
                return <NewReserve setLoading={setLoading} showMessage={showMessage} />;
            case '7':
                return <CurrentUserReserves setLoading={setLoading} showMessage={showMessage} />;
            case '8':
                return <Setting 
                    setLoading={setLoading} 
                    showMessage={showMessage}
                    cancelEdit={() => handleViewChange('dashboard')}
                    settingUpdated={() => handleViewChange('dashboard')}
                />;
            case '9':
                return <UserProfileComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    cancelEdit={() => handleViewChange('dashboard')}
                    profileUpdated={() => { 
                        handleViewChange('dashboard'); 
                        setProfileVersion(prev => prev + 1); 
                    }}
                />;
            case '10':
                return <CustomType setLoading={setLoading} showMessage={showMessage} />;
            case '11':
                return <User setLoading={setLoading} showMessage={showMessage} />;
            case '12':
                return <AdvanceSearch
                    setLoading={setLoading}
                    showMessage={showMessage}
                    userRole={localStorage.getItem('role')}
                />;
            case '13':
                return <Food setLoading={setLoading} showMessage={showMessage} />;
            case '14':
                return <FoodPricePeriod setLoading={setLoading} showMessage={showMessage} />;
            case '15':
                return <FoodListPeriod setLoading={setLoading} showMessage={showMessage} />;
            case '16':
                return <FoodReserve setLoading={setLoading} showMessage={showMessage} />;
            case '17':
                return <ParkingPricePeriod setLoading={setLoading} showMessage={showMessage} />;
            case '18':
                return <Kitchen setLoading={setLoading} showMessage={showMessage} />;
            case '19':
                return <Parking setLoading={setLoading} showMessage={showMessage} />;
            case '20':
                return <ObjectInstanceCalendar setLoading={setLoading} showMessage={showMessage} />;
                case 'support-contact':
            return <SupportContact 
                setLoading={setLoading} 
                showMessage={showMessage}
                supportLinks={supportLinks}
            />;
        case 'faq':
            return <FAQ 
                setLoading={setLoading} 
                showMessage={showMessage}
            />;
        case 'about-app':
            return <AboutApp 
                setLoading={setLoading} 
                showMessage={showMessage}
            />;
        case 'features':
            return <Features 
                setLoading={setLoading} 
                showMessage={showMessage}
            />;
        case 'developer':
            return <DeveloperInfo 
                setLoading={setLoading} 
                showMessage={showMessage}
                supportLinks={developerLinks}
            />;
        case 'website':
            return <WebsiteRedirect 
                setLoading={setLoading} 
                showMessage={showMessage}
                supportLinks={supportLinks}
            />;
        case 'tutorials':
            return <Tutorials 
                setLoading={setLoading} 
                showMessage={showMessage}
            />;
            default:
                return <DashboardComponent 
                    setLoading={setLoading} 
                    showMessage={showMessage}
                    handleViewChange={handleViewChange}
                />;
        }
    };

    // =================================================================
    // منوی موبایل
    // منوی موبایل - اصلاح شده با gap
const renderMobileMenu = () => (
    <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: token.colorBgContainer,
        borderTop: `1px solid ${token.colorBorder}`,
        padding: '8px', // 👈 پدینگ افقی را افزایش دادم (مثلاً 8px) و فقط یک مقدار دادم
        display: 'flex',
        justifyContent: 'space-between', // 👈 'space-between' بهتر است
        alignItems: 'center',
        boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
        zIndex: 1000,
        gap: '4px' // 👈 استفاده از gap برای فاصله بین دکمه ها
    }}>
        <Tooltip title="داشبورد">
            <Button
                type={view === 'dashboard' ? 'primary' : 'text'}
                icon={<HomeOutlined />}
                onClick={() => handleViewChange('dashboard')}
                style={{
                    flex: 1,
                    // margin: '0 2px', // 👈 حذف margin افقی
                    borderRadius: 12,
                    height: 56
                }}
            />
        </Tooltip>

        <Tooltip title="رزرو جدید">
            <Button
                type={view === '6' ? 'primary' : 'text'}
                icon={<PlusOutlined />}
                onClick={() => handleViewChange('6')}
                style={{
                    flex: 1,
                    // margin: '0 2px', // 👈 حذف margin افقی
                    borderRadius: 12,
                    height: 56
                }}
            />
        </Tooltip>
        <Tooltip title="رزرو غذا و پارکینگ">
            <Button
                type={view === '16' ? 'primary' : 'text'}
                icon={<CoffeeOutlined />}
                onClick={() => handleViewChange('16')}
                style={{
                    flex: 1,
                    // margin: '0 2px', // 👈 حذف margin افقی
                    borderRadius: 12,
                    height: 56
                }}
            />
        </Tooltip>

        <Tooltip title="منوی اصلی">
            <Button
                type="primary"
                icon={<AppstoreOutlined />}
                onClick={() => setMobileMenuOpen(true)}
                style={{
                    flex: 1,
                    // margin: '0 2px', // 👈 حذف margin افقی
                    borderRadius: 12,
                    height: 56
                }}
            />
        </Tooltip>
    </div>
);

    // =================================================================
    // منوی کشویی موبایل
    const renderMobileDrawer = () => (
        <Drawer
            title={
                <Space>
                    <AppstoreOutlined />
                    <span>منوی اصلی</span>
                </Space>
            }
            placement="bottom"
            height="85%"
            open={mobileMenuOpen}
            onClose={() => setMobileMenuOpen(false)}
            styles={{
                body: { padding: 0 },
                header: { 
                    borderBottom: `1px solid ${token.colorBorder}`,
                    padding: '16px 24px'
                }
            }}
        >
            <div style={{ padding: 16, height: '100%', overflow: 'auto' }}>
                {/* جستجو در منوی موبایل */}
                <div style={{ marginBottom: 16 }}>
                    <Search
                        placeholder="جستجو در منو..."
                        value={menuSearch}
                        onChange={(e) => setMenuSearch(e.target.value)}
                        allowClear
                        size="large"
                    />
                </div>

                {/* نمایش بر اساس جستجو */}
                {menuSearch ? (
                    <List
                        dataSource={mainMenuItems.filter(item => 
                            item.label.includes(menuSearch)
                        )}
                        renderItem={item => (
                            <List.Item 
                                style={{
                                    padding: '12px 16px',
                                    borderRadius: 8,
                                    marginBottom: 8,
                                    cursor: 'pointer',
                                    background: view === item.key ? `${colorTheme}10` : token.colorFillAlter
                                }}
                                onClick={() => handleViewChange(item.key)}
                            >
                                <Space>
                                    {item.icon}
                                    <Text strong>{item.label}</Text>
                                </Space>
                            </List.Item>
                        )}
                    />
                ) : (
                    <>
                        {/* گروه‌بندی در موبایل */}
                        {activeGroup ? (
                            <>
                                <Space style={{ marginBottom: 16, width: '100%' }}>
                                    <Button
                                        type="text"
                                        icon={<CloseOutlined />}
                                        onClick={() => setActiveGroup(null)}
                                    >
                                        بازگشت
                                    </Button>
                                    <Title level={5} style={{ margin: 0 }}>
                                        {menuGroups.find(g => g.key === activeGroup)?.label}
                                    </Title>
                                </Space>
                                
                                <Divider />
                                
                                <Space direction="vertical" style={{ width: '100%' }}>
                                    {menuGroups
                                        .find(g => g.key === activeGroup)
                                        ?.items
                                        .map(item => (
                                            <Button
                                                key={item.key}
                                                type={view === item.key ? 'primary' : 'default'}
                                                icon={item.icon}
                                                onClick={() => handleViewChange(item.key)}
                                                style={{
                                                    width: '100%',
                                                    justifyContent: 'flex-start',
                                                    height: 56,
                                                    borderRadius: 12,
                                                    marginBottom: 8
                                                }}
                                                size="large"
                                            >
                                                {item.label}
                                            </Button>
                                        ))
                                    }
                                </Space>
                            </>
                        ) : (
                            <>
                                <Title level={5} style={{ marginBottom: 16 }}>
                                    گروه‌ها
                                </Title>
                                <Space direction="vertical" style={{ width: '100%' }}>
                                    {menuGroups.map(group => (
                                        <Button
                                            key={group.key}
                                            type={activeGroup === group.key ? 'primary' : 'default'}
                                            icon={group.icon}
                                            onClick={() => setActiveGroup(group.key)}
                                            style={{
                                                width: '100%',
                                                justifyContent: 'flex-start',
                                                height: 56,
                                                borderRadius: 12,
                                                marginBottom: 8
                                            }}
                                            size="large"
                                        >
                                            {group.label}
                                        </Button>
                                    ))}
                                </Space>
                            </>
                        )}
                    </>
                )}
            </div>
        </Drawer>
    );

    // =================================================================
    // تنظیمات تم (نوار کناری دسکتاپ)
    // const renderThemeSettings = () => (
    //     <Card size="small" style={{ margin: 16, background: token.colorFillAlter }}>
    //         <Space direction="vertical" style={{ width: '100%' }}>
    //             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    //                 <Space>
    //                     <BulbOutlined />
    //                     <Text>تم تاریک</Text>
    //                 </Space>
    //                 <Switch
    //                     checked={darkMode}
    //                     onChange={setDarkMode}
    //                     size="small"
    //                 />
    //             </div>
                
    //             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    //                 <Space>
    //                     <FontSizeOutlined />
    //                     <Text>سایز فونت</Text>
    //                 </Space>
    //                 <Segmented
    //                     size="small"
    //                     options={[
    //                         { label: 'کوچک', value: 12 },
    //                         { label: 'متوسط', value: 14 },
    //                         { label: 'بزرگ', value: 16 }
    //                     ]}
    //                     value={fontSize}
    //                     onChange={setFontSize}
    //                 />
    //             </div>
                
    //             <div>
    //                 <Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>رنگ تم:</Text>
    //                 <Space wrap>
    //                     {[
    //                         { name: 'آبی', value: '#1890ff' },
    //                         { name: 'سبز', value: '#52c41a' },
    //                         { name: 'طلایی', value: '#faad14' },
    //                         { name: 'قرمز', value: '#f5222d' }
    //                     ].map(themeColor => (
    //                         <Tooltip title={themeColor.name} key={themeColor.value}>
    //                             <Button
    //                                 type="text"
    //                                 style={{
    //                                     width: 24,
    //                                     height: 24,
    //                                     minWidth: 24,
    //                                     padding: 0,
    //                                     backgroundColor: themeColor.value,
    //                                     border: colorTheme === themeColor.value ? `2px solid ${token.colorBorder}` : 'none'
    //                                 }}
    //                                 onClick={() => setColorTheme(themeColor.value)}
    //                             />
    //                         </Tooltip>
    //                     ))}
    //                 </Space>
    //             </div>
    //         </Space>
    //     </Card>
    // );

    // =================================================================
    return (
        <Layout style={layoutStyle} dir="rtl">
            {!isMobile ? (
                // حالت دسکتاپ
                <>
                    <Sider 
                        width={270} 
                        breakpoint="lg" 
                        collapsible 
                        collapsed={collapsed} 
                        onCollapse={(value) => setCollapsed(value)} 
                        style={{
                            ...siderStyle,
                            background: darkMode ? token.colorBgContainer : '#001529',
                            borderRight: `1px solid ${token.colorBorder}`
                        }}
                    >
                        <div style={{ padding: 24, borderBottom: `1px solid ${token.colorBorder}` }}>
                            <Row align="middle" gutter={12}>
                                <Col>
                                   <Avatar
        size="large"
        // style={{
        //     backgroundColor: colorTheme,
        //     boxShadow: `0 2px 8px ${colorTheme}40`
        // }}
        // icon={<RocketOutlined />} // 👈 این خط را حذف یا کامنت کنید
    >
        {/* از تگ <img> برای نمایش تصویر محلی استفاده کنید */}
        <img
            src="/icon-512x512.png" // 👈 مسیر فایل در پوشه public
            alt="App Icon"    // 👈 متن جایگزین برای دسترسی‌پذیری
            style={{ width: '100%', height: '100%', objectFit: 'cover' }} // 👈 برای اطمینان از پوشش کامل آواتار
        />
    </Avatar>
                                </Col>
                                <Col flex="auto">
                                    <Title level={5} style={{ margin: 0, color: darkMode ? token.colorText : '#fff' }}>
                                        سامانه حسینیه من
                                    </Title>
                                    <Text type="secondary" style={{ fontSize: 12, color: darkMode ? token.colorTextSecondary : 'rgba(255,255,255,0.65)' }}>
                                        {new Date().toLocaleDateString('fa-IR')}
                                    </Text>
                                </Col>
                            </Row>
                        </div>

                        <Menu
                            onClick={(e) => handleViewChange(e.key)}
                            style={{
                                ...menuStyle,
                                background: darkMode ? token.colorBgContainer : '#001529'
                            }}
                            theme={darkMode ? "light" : "dark"}
                            mode="inline"
                            selectedKeys={[view]}
                            items={mainMenuItems}
                        />

                        {/* {renderThemeSettings()} */}
                    </Sider>
                    
                    <Layout>
                        <Header style={{
                            ...headerStyle,
                            background: darkMode ? token.colorBgContainer : '#001529',
                            borderBottom: `1px solid ${token.colorBorder}`,
                            padding: '0 24px'
                        }}>
                            <Row justify="space-between" align="middle" style={{ height: '100%' }}>
<Col>
            <Space>
                {/* اضافه کردن دکمه بازگشت به داشبورد */}
                {view !== 'dashboard' && (
                    <Tooltip title="بازگشت به داشبورد">
                        <Button
                            type="text"
                            icon={<HomeOutlined />}
                            onClick={() => handleViewChange('dashboard')}
                            style={{ 
                                color: darkMode ? token.colorText : '#fff',
                                marginRight: 8
                            }}
                        />
                    </Tooltip>
                )}
                
                <Title level={4} style={{ 
                    margin: 0, 
                    color: darkMode ? token.colorText : '#fff' 
                }}>
                    {view === 'dashboard' ? 'داشبورد' : 
                     mainMenuItems.find(item => item.key === view)?.label || 'سیستم رزرواسیون'}
                </Title>
            </Space>
        </Col>                                
                                <Col>
                                    <Space size="middle">
                                        <Text strong style={{ 
                                            fontSize: 14,
                                            color: darkMode ? token.colorText : '#fff'
                                        }}>
                                            {/* // --- شروع اصلاح فرمت تاریخ برای JavaScript خالص --- */}
                    {(() => {
                        const today = new Date();
                        
                        // آبجکت‌های option را بدون type annotation تعریف می‌کنیم
                        const optionsWeekday = { weekday: 'long' };
                        const optionsDay = { day: 'numeric' };
                        const optionsMonth = { month: 'long' };
                        const optionsYear = { year: 'numeric' };

                        const weekday = today.toLocaleDateString('fa-IR', optionsWeekday);
                        const day = today.toLocaleDateString('fa-IR', optionsDay);
                        const month = today.toLocaleDateString('fa-IR', optionsMonth);
                        const year = today.toLocaleDateString('fa-IR', optionsYear);

                        // اجزا را به ترتیبی که می‌خواهید کنار هم قرار می‌دهیم
                        return `امروز ${weekday} ${day} ${month} ${year}`;
                    })()}
                    {/* // --- پایان اصلاح فرمت تاریخ --- */}
                                        </Text>
                                        
                                        <Tooltip title="تغییر ظاهر">
                                            <Switch
                                                checkedChildren={<BulbFilled />}
                                                unCheckedChildren={<BulbOutlined />}
                                                checked={darkMode}
                                                onChange={setDarkMode}
                                                size="small"
                                            />
                                        </Tooltip>
                                        
                                        <UserAvatarComponent
                                            setLoading={setLoading}
                                            showMessage={showMessage}
                                            profileVersion={profileVersion}
                                            editProfileClicked={() => handleViewChange('9')}
                                        />
                                    </Space>
                                </Col>
                            </Row>
                        </Header>

                        <Layout.Content style={{
                            background: darkMode ? token.colorBgContainer : '#f0f2f5',
                            minHeight: 'calc(100vh - 64px)',
                            overflow: 'auto'
                        }}>
                            {renderContent()}
                        </Layout.Content>
                    </Layout>
                </>
            ) : (
                // حالت موبایل
                <>
                    <Layout>
                        <Header style={{
    ...headerStyle,
    background: darkMode ? token.colorBgContainer : '#001529',
    borderBottom: `1px solid ${token.colorBorder}`,
    padding: isMobile ? '0 12px' : '0 24px',
    height: isMobile ? 56 : 64
}}>
    <Row justify="space-between" align="middle" style={{ height: '100%' }}>
        <Col>
            <Space>
                {/* آیکون منو در موبایل */}
                {isMobile && (
                    <Button
                        type="text"
                        icon={<MenuOutlined />}
                        onClick={() => setMobileMenuOpen(true)}
                        size="small"
                        style={{ color: darkMode ? token.colorText : '#fff' }}
                    />
                )}
                
                {/* دکمه بازگشت به داشبورد - همیشه بجز زمانی که در داشبورد هستیم */}
                {view !== 'dashboard' && (
                    <Tooltip title="بازگشت به داشبورد">
                        <Button
                            type="text"
                            icon={<HomeOutlined />}
                            onClick={() => handleViewChange('dashboard')}
                            size={isMobile ? "small" : "middle"}
                            style={{ 
                                color: darkMode ? token.colorText : '#fff',
                                marginRight: isMobile ? 4 : 8
                            }}
                        />
                    </Tooltip>
                )}
                
                {/* عنوان صفحه */}
                <Title 
                    level={isMobile ? 5 : 4} 
                    style={{ 
                        margin: 0, 
                        color: darkMode ? token.colorText : '#fff',
                        fontSize: isMobile ? 16 : 20
                    }}
                >
                    {view === 'dashboard' ? 'داشبورد' : 
                     (isMobile 
                        ? (mainMenuItems.find(item => item.key === view)?.label?.substring(0, 15) + '...')
                        : mainMenuItems.find(item => item.key === view)?.label || 'سیستم رزرواسیون'
                     )}
                </Title>
            </Space>
        </Col>
        
        <Col>
            <Space size={isMobile ? "small" : "middle"}>
                {/* تاریخ - فقط در دسکتاپ نمایش داده شود */}
                {!isMobile && (
                    <Text strong style={{ 
                        fontSize: 14,
                        color: darkMode ? token.colorText : '#fff'
                    }}>
                        {new Date().toLocaleDateString('fa-IR', { 
                            weekday: 'long', 
                            year: 'numeric', 
                            month: 'long', 
                            day: 'numeric' 
                        })}
                    </Text>
                )}
                
                {/* تغییر تم - فقط در دسکتاپ */}
                {!isMobile && (
                    <Tooltip title="تغییر تم">
                        <Switch
                            checkedChildren={<BulbFilled />}
                            unCheckedChildren={<BulbOutlined />}
                            checked={darkMode}
                            onChange={setDarkMode}
                            size="small"
                        />
                    </Tooltip>
                )}
                
                {/* آواتار کاربر */}
                <UserAvatarComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    profileVersion={profileVersion}
                    editProfileClicked={() => handleViewChange('9')}
                    compact={isMobile} // حالت فشرده در موبایل
                />
            </Space>
        </Col>
    </Row>
</Header>

                        <Layout.Content style={{
                            background: token.colorBgContainer,
                            minHeight: 'calc(100vh - 64px)',
                            paddingBottom: 80, // فضای برای منوی پایینی
                            overflow: 'auto'
                        }}>
                            {renderContent()}
                        </Layout.Content>

                        {/* منوی پایینی موبایل */}
                        {renderMobileMenu()}
                        {renderMobileDrawer()}
                    </Layout>
                </>
            )}

            {/* دکمه‌های شناور */}
            {view !== 'dashboard' && (
                <FloatButton
                    icon={<HomeOutlined />}
                    onClick={() => handleViewChange('dashboard')}
                    tooltip="بازگشت به داشبورد"
                    style={{ right: 24, bottom: 24 }}
                />
            )}
            
            <FloatButton.BackTop visibilityHeight={100} />
        </Layout>
    );
};

export default Admin;

// -----------------------------آیکون خوب --------------------------------------------------
// import React, { useEffect, useState } from 'react';
// import { Card, Col, Layout, Row, Grid, Menu, Button, Drawer } from 'antd';
// import {
//     BookOutlined,
//     CalculatorOutlined,
//     CoffeeOutlined,
//     CopyOutlined,
//     DollarOutlined,
//     FieldTimeOutlined,
//     GroupOutlined,
//     HistoryOutlined,
//     MoneyCollectOutlined,
//     PlusOutlined,
//     SearchOutlined,
//     SettingOutlined,
//     TeamOutlined,
//     UnorderedListOutlined,
//     UserOutlined,
//     HomeOutlined,
//     MenuOutlined,
// } from '@ant-design/icons';

// // ... (همانند قبل، import کامپوننت‌های مختلف)
// import { ObjectType } from './ObjectType';
// import { ObjectInstance } from './ObjectInstance';
// import { Category } from './Category';
// import { Price } from './Price';
// import { Period } from './Period';
// import { NewReserve } from './NewReserve';
// import { Setting } from './Setting';
// import { UserAvatarComponent } from '../Components/Profile/UserAvatarComponent';
// import { UserProfileComponent } from '../Components/Profile/UserProfileComponent';
// import { CustomType } from './CustomType';
// import { User } from './User';
// import { CurrentUserReserves } from './CurrentUserReserves';
// import { AdvanceSearch } from './AdvanceSearch';
// import { Food } from './Food';
// import { FoodPricePeriod } from './FoodPricePeriod';
// import { FoodListPeriod } from './FoodListPeriod';
// import { FoodReserve } from './FoodReserve';
// import { ParkingPricePeriod } from './ParkingPricePeriod';
// import { Kitchen } from './Kitchen';
// import { Parking } from './Parking';
// import { ObjectInstanceCalendar } from './ObjectInstanceCalendar';


// const menuItemsData = [
//     {
//         key: '1',
//         icon: <BookOutlined />, // آیکون‌ها دیگر نیاز به font-size در اینجا ندارند
//         label: 'مدیریت نوع موجودیت ها',
//         roles: ['SuperAdmin', 'Admin'],
//         component: ObjectType,
//         description: 'مدیریت انواع مختلف موجودیت‌ها'
//     },
//     {
//         key: '2',
//         icon: <CopyOutlined />,
//         label: 'مدیریت موجودیت ها',
//         roles: ['SuperAdmin', 'Admin'],
//         component: ObjectInstance,
//         description: 'ایجاد، ویرایش و حذف موجودیت‌ها'
//     },
//     {
//         key: '10',
//         icon: <UnorderedListOutlined />,
//         label: 'مدیریت لیست ها',
//         roles: ['SuperAdmin'],
//         component: CustomType,
//         description: 'مدیریت لیست‌های سفارشی'
//     },
//     {
//         key: '3',
//         icon: <GroupOutlined />,
//         label: 'مدیریت دسته بندی ها',
//         roles: ['SuperAdmin', 'Admin'],
//         component: Category,
//         description: 'دسته‌بندی و گروه‌بندی موجودیت‌ها'
//     },
//     {
//         key: '4',
//         icon: <CalculatorOutlined />,
//         label: 'مدیریت قیمت گذاری',
//         roles: ['SuperAdmin', 'Admin'],
//         component: Price,
//         description: 'تعیین و مدیریت قیمت‌های خدمات'
//     },
//     {
//         key: '5',
//         icon: <FieldTimeOutlined />,
//         label: 'مدیریت دوره های رزرو',
//         roles: ['SuperAdmin', 'Admin'],
//         component: Period,
//         description: 'تنظیم زمان‌بندی و دوره‌های قابل رزرو'
//     },
//     {
//         key: '13',
//         icon: <CoffeeOutlined />,
//         label: 'مدیریت غذاها',
//         roles: ['SuperAdmin', 'Admin'],
//         component: Food,
//         description: 'مدیریت منو و آیتم‌های غذایی'
//     },
//     {
//         key: '14',
//         icon: <DollarOutlined />,
//         label: 'مدیریت قیمت گذاری غذا',
//         roles: ['SuperAdmin', 'Admin'],
//         component: FoodPricePeriod,
//         description: 'تعیین قیمت برای غذاها'
//     },
//     {
//         key: '17',
//         icon: <DollarOutlined />,
//         label: 'مدیریت قیمت گذاری پارکینگ',
//         roles: ['SuperAdmin', 'Admin'],
//         component: ParkingPricePeriod,
//         description: 'تنظیم قیمت برای خدمات پارکینگ'
//     },
//     {
//         key: '15',
//         icon: <CoffeeOutlined />,
//         label: 'مدیریت برنامه غذایی',
//         roles: ['SuperAdmin', 'Admin'],
//         component: FoodListPeriod,
//         description: 'برنامه‌ریزی و زمان‌بندی وعده‌های غذایی'
//     },
//     {
//         key: '11',
//         icon: <TeamOutlined />,
//         label: 'مدیریت کاربران',
//         roles: ['SuperAdmin', 'Admin'],
//         component: User,
//         description: 'مدیریت حساب‌ها و نقش‌های کاربران'
//     },
//     {
//         key: '12',
//         icon: <SearchOutlined />,
//         label: 'جستجوی پیشرفته',
//         roles: ['SuperAdmin', 'Admin', 'Reception'],
//         component: AdvanceSearch,
//         description: 'جستجوی دقیق و فیلتر شده'
//     },
//     {
//         key: '18',
//         icon: <SearchOutlined />,
//         label: 'گزارشات آشپزخانه',
//         roles: ['SuperAdmin', 'Admin', 'Reception'],
//         component: Kitchen,
//         description: 'گزارشات فعالیت‌های آشپزخانه'
//     },
//     {
//         key: '19',
//         icon: <SearchOutlined />,
//         label: 'گزارشات پارکینگ',
//         roles: ['SuperAdmin', 'Admin', 'Reception'],
//         component: Parking,
//         description: 'گزارشات استفاده از پارکینگ'
//     },
//     {
//         key: '20',
//         icon: <SearchOutlined />,
//         label: 'گزارشات اتاق ها',
//         roles: ['SuperAdmin', 'Admin'],
//         component: ObjectInstanceCalendar,
//         description: 'گزارشات رزرو و وضعیت اتاق‌ها'
//     },
//     {
//         key: '7',
//         icon: <HistoryOutlined />,
//         label: 'رزروهای شما',
//         roles: ['SuperAdmin', 'Admin', 'Reception', 'User'],
//         component: CurrentUserReserves,
//         description: 'مشاهده و پیگیری رزروهای شما'
//     },
//     {
//         key: '16',
//         icon: <PlusOutlined />,
//         label: 'رزرو غذا و پارکینگ',
//         roles: ['SuperAdmin', 'Admin', 'Reception', 'User'],
//         component: FoodReserve,
//         description: 'رزرو سرویس‌های غذا و پارکینگ'
//     },
//     {
//         key: '6',
//         icon: <PlusOutlined />,
//         label: 'رزرو جدید',
//         roles: ['SuperAdmin', 'Admin', 'Reception', 'User'],
//         component: NewReserve,
//         description: 'ایجاد رزرو جدید'
//     },
//     {
//         key: '8',
//         icon: <SettingOutlined />,
//         label: 'تنظیمات',
//         roles: ['SuperAdmin', 'Admin'],
//         component: Setting,
//         description: 'تنظیمات کلی سیستم'
//     },
//     {
//         key: '9',
//         icon: <UserOutlined />,
//         label: 'پروفایل',
//         roles: ['SuperAdmin', 'Admin', 'Reception', 'User'],
//         component: UserProfileComponent,
//         description: 'مشاهده و ویرایش اطلاعات پروفایل'
//     },
// ];

// export const Admin = ({ setLoading, showMessage }) => {
//     const [view, setView] = useState('home');
//     const [profileVersion, setProfileVersion] = useState(1);
//     const [drawerVisible, setDrawerVisible] = useState(false);
//     const screens = Grid.useBreakpoint();
//     const userRole = localStorage.getItem('role');

//     const resetView = () => {
//         setView('home');
//         setDrawerVisible(false);
//     };

//     const filteredMenuItems = menuItemsData.filter(item =>
//         item.roles.includes(userRole)
//     );

//     const CurrentViewComponent = menuItemsData.find(item => item.key === String(view))?.component;
//     const CurrentViewTitle = menuItemsData.find(item => item.key === String(view))?.label;


//     return (
//         <Layout style={{ minHeight: '100vh' }}>
//             <Layout.Header style={{
//                 backgroundColor: '#001529',
//                 padding: '0 20px',
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//                 height: '64px',
//             }}>
//                 <div style={{ display: 'flex', alignItems: 'center' }}>
//                     {screens.md ? (
//                         view !== 'home' && (
//                             <Button
//                                 type="primary"
//                                 icon={<HomeOutlined />}
//                                 onClick={resetView}
//                                 style={{ marginRight: '16px' }}
//                             >
//                                 صفحه اصلی
//                             </Button>
//                         )
//                     ) : (
//                         view === 'home' ? (
//                             <Button
//                                 type="text"
//                                 icon={<MenuOutlined style={{ color: '#fff' }} />}
//                                 onClick={() => setDrawerVisible(true)}
//                                 style={{ marginRight: '16px' }}
//                             />
//                         ) : (
//                             // Changed this button to just an icon for compactness in mobile view of a form
//                             <Button
//                                 type="text"
//                                 icon={<HomeOutlined style={{ color: '#fff', fontSize: '20px' }} />}
//                                 onClick={resetView}
//                                 style={{ marginRight: '8px' }}
//                             />
//                         )
//                     )}
//                     {!screens.md && view !== 'home' && (
//                          <span style={{ color: '#fff', fontSize: '16px', fontWeight: 'bold' }}>{CurrentViewTitle}</span>
//                     )}

//                 </div>
//                 <UserAvatarComponent
//                     setLoading={setLoading}
//                     showMessage={showMessage}
//                     profileVersion={profileVersion}
//                     editProfileClicked={() => setView('9')}
//                 />
//             </Layout.Header>

//             <Layout.Content style={{ margin: '16px', overflow: 'initial' }}> {/* کاهش Margin */}
//                 {view === 'home' ? (
//                     <Row gutter={[12, 12]}> {/* کاهش Gutter */}
//                         {filteredMenuItems.map(item => (
//                             <Col
//                                 key={item.key}
//                                 xs={12}    // موبایل: 2 ستون (24/12=2)
//                                 sm={8}     // تبلت کوچک: 3 ستون (24/8=3)
//                                 md={6}     // تبلت متوسط/دسکتاپ کوچک: 4 ستون (24/6=4)
//                                 lg={4}     // دسکتاپ متوسط: 6 ستون (24/4=6)
//                                 xl={3}     // دسکتاپ بزرگ: 8 ستون (24/3=8)
//                             >
//                                 <Card
//                                     hoverable
//                                     onClick={() => setView(item.key)}
//                                     style={{
//                                         textAlign: 'center',
//                                         height: '100%',
//                                         display: 'flex',
//                                         flexDirection: 'column',
//                                         justifyContent: 'center',
//                                         alignItems: 'center',
//                                         padding: '8px', // کاهش Padding داخلی کارت
//                                         backgroundColor: view === item.key ? '#e6f7ff' : '#fff',
//                                         borderColor: view === item.key ? '#1890ff' : '#d9d9d9',
//                                         borderWidth: view === item.key ? '2px' : '1px',
//                                         transition: 'all 0.3s',
//                                     }}
//                                     bodyStyle={{ padding: '10px 5px' }} // Padding برای محتوای body Card
//                                 >
//                                     <div style={{ fontSize: '32px', marginBottom: '8px' }}> {/* کاهش اندازه آیکون */}
//                                         {React.cloneElement(item.icon, { style: { color: item.icon.props.style?.color || '#1890ff' } })}
//                                     </div>
//                                     <Card.Meta
//                                         title={<span style={{ fontWeight: 'bold', fontSize: '13px' }}>{item.label}</span>} // کاهش اندازه فونت
//                                         description={<span style={{ fontSize: '11px', color: '#888' }}>{item.description}</span>} // کاهش اندازه فونت و رنگ
//                                     />
//                                 </Card>
//                             </Col>
//                         ))}
//                     </Row>
//                 ) : (
//                     <div style={{ padding: 24, background: '#fff', minHeight: 360 }}> {/* حذف marginTop */}
//                         {CurrentViewComponent && (
//                             <CurrentViewComponent
//                                 setLoading={setLoading}
//                                 showMessage={showMessage}
//                                 cancelEdit={resetView}
//                                 profileUpdated={() => { resetView(); setProfileVersion(profileVersion + 1); }}
//                                 settingUpdated={resetView}
//                                 userRole={userRole}
//                             />
//                         )}
//                     </div>
//                 )}
//             </Layout.Content>

//             <Drawer
//                 title="منوی اصلی"
//                 placement="right"
//                 closable={true}
//                 onClose={() => setDrawerVisible(false)}
//                 open={drawerVisible}
//                 bodyStyle={{ padding: 0 }}
//             >
//                 <Menu
//                     onClick={(e) => {
//                         setView(e.key);
//                         setDrawerVisible(false);
//                     }}
//                     mode="inline"
//                     selectedKeys={[String(view)]}
//                     style={{ height: '100%', borderRight: 0 }}
//                     items={filteredMenuItems.map(item => ({
//                         key: item.key,
//                         icon: React.cloneElement(item.icon, { style: { fontSize: '18px', color: item.icon.props.style?.color || '#1890ff' } }), // کوچکتر کردن آیکون در منوی دراور
//                         label: item.label,
//                     }))}
//                 />
//             </Drawer>
//         </Layout>
//     );
// };
// ------------------------------- اصلی ------------------------------------------
////////////// ---------------------------------
// // ======================================================================
// export const Admin = ({ setLoading, showMessage }) => {
//     // =================================================================
//     const [view, setView] = useState(0);
//     const [collapsed, setCollapsed] = useState(false);
//     const [profileVersion, setProfileVersion] = useState(1);
//     // =================================================================
//     return (
//         <>
//             <Layout style={layoutStyle}>
//                 <Sider width={270} breakpoint="lg" collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)} style={siderStyle}>
//                     <Menu
//                         onClick={(e) => setView(e.key)}
//                         style={menuStyle}
//                         theme="dark"
//                         mode="inline"
//                         defaultSelectedKeys={['0']}
//                         items={[
//                             (localStorage.getItem('role') == 'SuperAdmin' || localStorage.getItem('role') == 'Admin') ? {
//                                 key: '1',
//                                 icon: <BookOutlined />,
//                                 label: 'مدیریت نوع موجودیت ها',
//                             } : null,
//                             (localStorage.getItem('role') == 'SuperAdmin' || localStorage.getItem('role') == 'Admin') ? {
//                                 key: '2',
//                                 icon: <CopyOutlined />,
//                                 label: 'مدیریت موجودیت ها',
//                             } : null,
//                             (localStorage.getItem('role') == 'SuperAdmin') ? {
//                                 key: '10',
//                                 icon: <UnorderedListOutlined />,
//                                 label: 'مدیریت لیست ها',
//                             } : null,
//                             (localStorage.getItem('role') == 'SuperAdmin' || localStorage.getItem('role') == 'Admin') ? {
//                                 key: '3',
//                                 icon: <GroupOutlined />,
//                                 label: 'مدیریت دسته بندی ها',
//                             } : null,
//                             (localStorage.getItem('role') == 'SuperAdmin' || localStorage.getItem('role') == 'Admin') ? {
//                                 key: '4',
//                                 icon: <CalculatorOutlined />,
//                                 label: 'مدیریت قیمت گذاری',
//                             } : null,
//                             (localStorage.getItem('role') == 'SuperAdmin' || localStorage.getItem('role') == 'Admin') ? {
//                                 key: '5',
//                                 icon: <FieldTimeOutlined />,
//                                 label: 'مدیریت دوره های رزرو',
//                             } : null,
//                             (localStorage.getItem('role') == 'SuperAdmin' || localStorage.getItem('role') == 'Admin') ? {
//                                 key: '13',
//                                 icon: <CoffeeOutlined />,
//                                 label: 'مدیریت غذاها',
//                             } : null,
//                             (localStorage.getItem('role') == 'SuperAdmin' || localStorage.getItem('role') == 'Admin') ? {
//                                 key: '14',
//                                 icon: <DollarOutlined />,
//                                 label: 'مدیریت قیمت گذاری غذا',
//                             } : null,
//                             (localStorage.getItem('role') == 'SuperAdmin' || localStorage.getItem('role') == 'Admin') ? {
//                                 key: '17',
//                                 icon: <DollarOutlined />,
//                                 label: 'مدیریت قیمت گذاری پارکینگ',
//                             } : null,
//                             (localStorage.getItem('role') == 'SuperAdmin' || localStorage.getItem('role') == 'Admin') ? {
//                                 key: '15',
//                                 icon: <CoffeeOutlined />,
//                                 label: 'مدیریت برنامه غذایی',
//                             } : null,

//                             (localStorage.getItem('role') == 'SuperAdmin' || localStorage.getItem('role') == 'Admin') ? {
//                                 key: '11',
//                                 icon: <TeamOutlined />,
//                                 label: 'مدیریت کاربران',
//                             } : null,



//                             (localStorage.getItem('role') == 'SuperAdmin' ||
//                                 localStorage.getItem('role') == 'Admin' ||
//                                 localStorage.getItem('role') == 'Reception') ? {
//                                 key: '12',
//                                 icon: <SearchOutlined />,
//                                 label: 'جستجوی پیشرفته',
//                             } : null,

//                             (localStorage.getItem('role') == 'SuperAdmin' ||
//                                 localStorage.getItem('role') == 'Admin' ||
//                                 localStorage.getItem('role') == 'Reception') ? {
//                                 key: '18',
//                                 icon: <SearchOutlined />,
//                                 label: 'گزارشات آشپزخانه',
//                             } : null,
//                             (localStorage.getItem('role') == 'SuperAdmin' ||
//                                 localStorage.getItem('role') == 'Admin' ||
//                                 localStorage.getItem('role') == 'Reception') ? {
//                                 key: '19',
//                                 icon: <SearchOutlined />,
//                                 label: 'گزارشات پارکینگ',
//                             } : null,
//                             (localStorage.getItem('role') == 'SuperAdmin' ||
//                             localStorage.getItem('role') == 'Admin' ) ? {
//                             key: '20',
//                             icon: <SearchOutlined />,
//                             label: 'گزارشات اتاق ها',
//                         } : null,
//                             {
//                                 key: '7',
//                                 icon: <HistoryOutlined />,
//                                 label: 'رزروهای شما',
//                             },
//                             {
//                                 key: '16',
//                                 icon: <PlusOutlined />,
//                                 label: 'رزرو غذا و پارکنیگ',
//                             },
//                             {
//                                 key: '6',
//                                 icon: <PlusOutlined />,
//                                 label: 'رزرو جدید',
//                             },

//                             (localStorage.getItem('role') == 'SuperAdmin' || localStorage.getItem('role') == 'Admin') ? {
//                                 key: '8',
//                                 icon: <SettingOutlined />,
//                                 label: 'تنظیمات',
//                             } : null,
//                             {
//                                 key: '9',
//                                 icon: <UserOutlined />,
//                                 label: 'پروفایل',
//                             },
     
//                         ]}
//                     />
//                 </Sider>
//                 <Layout>
//                     <Header style={headerStyle}>
//                         <Row>
//                             <Col xs={12} sm={14} md={16} lg={18} xl={18} >
//                             </Col>
//                             <Col xs={12} sm={10} md={8} lg={6} xl={6} >
//                                 <UserAvatarComponent
//                                     setLoading={setLoading}
//                                     showMessage={showMessage}
//                                     profileVersion={profileVersion}
//                                     editProfileClicked={() => setView(9)}
//                                 />
//                             </Col>
//                         </Row>
//                     </Header>


//                     {view == 1 ?
//                         <ObjectType
//                             setLoading={setLoading}
//                             showMessage={showMessage} />
//                         : <></>}

//                     {view == 2 ?
//                         <ObjectInstance
//                             setLoading={setLoading}
//                             showMessage={showMessage} />
//                         : <></>}

//                     {view == 3 ?
//                         <Category
//                             setLoading={setLoading}
//                             showMessage={showMessage} />
//                         : <></>}

//                     {view == 4 ?
//                         <Price
//                             setLoading={setLoading}
//                             showMessage={showMessage} />
//                         : <></>}

//                     {view == 5 ?
//                         <Period
//                             setLoading={setLoading}
//                             showMessage={showMessage} />
//                         : <></>}

//                     {view == 6 ?
//                         <NewReserve
//                             setLoading={setLoading}
//                             showMessage={showMessage} />
//                         : <></>}

//                     {view == 7 ?
//                         <CurrentUserReserves
//                             setLoading={setLoading}
//                             showMessage={showMessage} />
//                         : <></>}

//                     {view == 8 ?
//                         <Setting
//                             setLoading={setLoading}
//                             showMessage={showMessage}
//                             cancelEdit={() => setView(0)}
//                             settingUpdated={() => setView(0)} />
//                         : <></>}

//                     {view == 9 ?
//                         <UserProfileComponent
//                             setLoading={setLoading}
//                             showMessage={showMessage}
//                             cancelEdit={() => setView(0)}
//                             profileUpdated={() => { setView(0); setProfileVersion(profileVersion + 1) }} />
//                         : <></>}

//                     {view == 10 ?
//                         <CustomType
//                             setLoading={setLoading}
//                             showMessage={showMessage}
//                         /> : <></>}

//                     {view == 11 ?
//                         <User
//                             setLoading={setLoading}
//                             showMessage={showMessage}
//                         /> : <></>}

//                     {view == 12 ?
//                         <AdvanceSearch
//                             setLoading={setLoading}
//                             showMessage={showMessage}
//                             userRole={localStorage.getItem('role')}
//                         /> : <></>}
//                     {view == 13 ?
//                         <Food
//                             setLoading={setLoading}
//                             showMessage={showMessage} />
//                         : <></>}
//                     {view == 14 ?
//                         <FoodPricePeriod
//                             setLoading={setLoading}
//                             showMessage={showMessage} />
//                         : <></>}
//                     {view == 15 ?
//                         <FoodListPeriod
//                             setLoading={setLoading}
//                             showMessage={showMessage} />
//                         : <></>}
//                     {view == 16 ?
//                         <FoodReserve
//                             setLoading={setLoading}
//                             showMessage={showMessage} />
//                         : <></>}
//                     {view == 17 ?
//                         <ParkingPricePeriod
//                             setLoading={setLoading}
//                             showMessage={showMessage} />
//                         : <></>}
//                     {view == 18 ?
//                         <Kitchen
//                             setLoading={setLoading}
//                             showMessage={showMessage} />
//                         : <></>}
//                     {view == 19 ?
//                         <Parking
//                             setLoading={setLoading}
//                             showMessage={showMessage} />
//                         : <></>}
//                     {view == 20 ?
//                         <ObjectInstanceCalendar
//                             setLoading={setLoading}
//                             showMessage={showMessage} />
//                         : <></>}


//                 </Layout>
//             </Layout>
//         </>
//     )
// }
